module.exports = __webpack_public_path__ + "img/local_video_close2.869521dd.svg";